import {Translate} from "./Translate";


export const RWN = {
    admin: Translate.admin,
    user: Translate.user,
};
export const platforms = {
    ps: Translate.ps,
    xbox: Translate.xbox,
    pc: Translate.pc,


};
export const platformsWithName = [
    {
        value: "ps",
        name : Translate.ps
    },
    {
        value: "xbox",
        name : Translate.xbox
    },
    {
        value: "pc",
        name : Translate.pc
    },
];
export const rolesWithName = [
    {
        value: "admin",
        type: "admin",
        name : Translate.admin
    },
    {
        value: "user",
        type: "normal",
        name : Translate.user
    },

];
export const typesWithName = [
    {
        value: "admin",
        name : Translate.adminType
    },
    {
        value: "normal",
        name : Translate.normalType
    },
];

export const  getRoleName = (role) => {
    let roleName = '';
     rolesWithName.map(row => {
        if(row.value === role){
            roleName = row.name;
        }
        return true
    })
    return roleName;
}

export const TablePage = 10;
export const TableCount = [10,20,50,100,200];